import { gql } from '@apollo/client'

export const GET_ALL_JURISDICTION_SUBS = gql`
  query GetAllJurisdictionsSub(
    $searchQuery: String
    $limit: Int
    $offset: Int
  ) {
    getAllJurisdictionsSub(
      searchQuery: $searchQuery
      limit: $limit
      offset: $offset
    ) {
      count
      rows {
        id
        name
      }
    }
  }
`

export const GET_ONE_JURISDICTION_SUB = gql`
query GetOneJurisdictionSub($getOneJurisdictionSubId: Int!) {
    getOneJurisdictionSub(id: $getOneJurisdictionSubId) {
      id
      name
      jurisdiction_id
      geofence
    }
  }
`
export const GET_JURISDICTION_GROUPS_CATEGORIES_SUB_BY_SUB_JURISDICTION_ID = gql`
  mutation GetjurisdictionGroupsCategoriesSubBySubJurisdictionId($id: Int!) {
    getjurisdictionGroupsCategoriesSubBySubJurisdictionId(id: $id) {
      sub_category_id
      sub_jurisdiction_id
    }
  }
`
export const CREATE_SUB_JURISDICTIONS = gql`
    mutation CreateSubJurisdictions($inputSubJurisdictions: InputSubJurisdictions!) {
        createSubJurisdictions(inputSubJurisdictions: $inputSubJurisdictions)
    }
`

export const UPDATE_SUB_JURISDICTIONS = gql`
    mutation UpdateSubJurisdictions($subsOfJurisdiction: InputSubJurisdictionsUpdate!) {
        updateSubJurisdictions(SubsOfJurisdiction: $subsOfJurisdiction)
    }
`
export const DELETE_SUB_JURISDICTIONS = gql`
    mutation DeleteSubJurisdictions($id: Int!) {
        deleteSubJurisdictions(id: $id)
    }
`
export const SUBJURISDICTIONS_TO_GROUPS_CATEGORIES_SUB = gql`
  mutation SubJurisdictionsToGroupsCategoriesSub($subJurisdictionId: Int!, $categoriesSubIds: [Int!]!) {
    subJurisdictionsToGroupsCategoriesSub(sub_jurisdiction_id: $subJurisdictionId, categories_sub_ids: $categoriesSubIds)
  }
`
